/* ============================================================
   SIMPATICO CUSTOM — landing page behavior
   Vanilla JS. Page must remain functional if this never runs:
   configurator degrades to static content, form still posts.
   ============================================================ */
(function () {
  'use strict';

  /* ---------- configurator ---------- */
  var dataEl = document.getElementById('sc-config-data');
  var configRoot = document.getElementById('sc-configurator');
  var config = null;
  var state = { tier: 'gt', addons: new Set() };

  function money(n) {
    return '$' + n.toLocaleString('en-US');
  }

  function tierById(id) {
    for (var i = 0; i < config.tiers.length; i++) {
      if (config.tiers[i].id === id) return config.tiers[i];
    }
    return config.tiers[0];
  }

  function isIncluded(addon) {
    return addon.includedIn.indexOf(state.tier) !== -1;
  }

  function total() {
    var t = tierById(state.tier).price;
    config.addons.forEach(function (a) {
      if (state.addons.has(a.id) && !isIncluded(a)) t += a.price;
    });
    return t;
  }

  function render() {
    if (!configRoot) return;
    var tier = tierById(state.tier);

    /* pills */
    configRoot.querySelectorAll('.sc-pill').forEach(function (pill) {
      var on = pill.getAttribute('data-tier') === state.tier;
      pill.setAttribute('aria-checked', on ? 'true' : 'false');
      pill.tabIndex = on ? 0 : -1;
    });

    /* addon rows */
    configRoot.querySelectorAll('.sc-addon').forEach(function (row) {
      var id = row.getAttribute('data-addon');
      var addon = null;
      config.addons.forEach(function (a) { if (a.id === id) addon = a; });
      if (!addon) return;
      var included = isIncluded(addon);
      var checked = included || state.addons.has(id);
      row.classList.toggle('sc-addon--included', included);
      row.setAttribute('aria-checked', checked ? 'true' : 'false');
      row.setAttribute('aria-disabled', included ? 'true' : 'false');
      row.tabIndex = included ? -1 : 0;
      row.querySelector('.sc-addon__box').textContent = checked ? '✓' : '';
      row.querySelector('.sc-addon__price').textContent =
        included ? 'Included' : '+' + money(addon.price);
    });

    /* summary */
    var sumTier = document.getElementById('sc-summary-tier');
    var sumLines = document.getElementById('sc-summary-lines');
    var sumTotal = document.getElementById('sc-summary-total');
    if (sumTier) sumTier.textContent = tier.name + ' BUILD';
    if (sumLines) {
      var html = '<div class="sc-summary__line"><span>Base build</span><span>' +
        money(tier.price) + '</span></div>';
      var any = false;
      config.addons.forEach(function (a) {
        if (state.addons.has(a.id) && !isIncluded(a)) {
          any = true;
          html += '<div class="sc-summary__line sc-summary__line--addon"><span>+ ' +
            a.name + '</span><span>+' + money(a.price) + '</span></div>';
        }
      });
      if (!any) {
        html += '<div class="sc-summary__line sc-summary__line--empty"><span>No add-ons selected</span></div>';
      }
      sumLines.innerHTML = html;
    }
    if (sumTotal) sumTotal.textContent = money(total());

    updateHiddenField();
  }

  /* hidden form field: carry the configurator selection into the consult email */
  function updateHiddenField() {
    var field = document.getElementById('sc-config-selection');
    if (!field || !config) return;
    var tier = tierById(state.tier);
    var parts = [tier.name + ' build (' + money(tier.price) + ')'];
    config.addons.forEach(function (a) {
      if (state.addons.has(a.id) && !isIncluded(a)) {
        parts.push('+ ' + a.name + ' (+' + money(a.price) + ')');
      }
    });
    parts.push('Estimated total: ' + money(total()));
    field.value = parts.join('; ');
  }

  function setTier(id) {
    if (!config) return;
    state.tier = id;
    render();
  }

  function toggleAddon(id) {
    var addon = null;
    config.addons.forEach(function (a) { if (a.id === id) addon = a; });
    if (!addon || isIncluded(addon)) return;
    if (state.addons.has(id)) state.addons.delete(id);
    else state.addons.add(id);
    render();
  }

  if (dataEl && configRoot) {
    try {
      config = JSON.parse(dataEl.textContent);
    } catch (e) {
      config = null;
    }
  }

  if (config) {
    state.tier = config.defaultTier || (config.tiers[0] && config.tiers[0].id);

    configRoot.querySelectorAll('.sc-pill').forEach(function (pill) {
      pill.addEventListener('click', function () {
        setTier(pill.getAttribute('data-tier'));
      });
      pill.addEventListener('keydown', function (e) {
        if (e.key === ' ' || e.key === 'Enter') {
          e.preventDefault();
          setTier(pill.getAttribute('data-tier'));
        }
      });
    });

    configRoot.querySelectorAll('.sc-addon').forEach(function (row) {
      row.addEventListener('click', function () {
        toggleAddon(row.getAttribute('data-addon'));
      });
      row.addEventListener('keydown', function (e) {
        if (e.key === ' ' || e.key === 'Enter') {
          e.preventDefault();
          toggleAddon(row.getAttribute('data-addon'));
        }
      });
    });

    /* tier-card "CONFIGURE →" buttons: select tier, then follow the anchor */
    document.querySelectorAll('[data-sc-configure-tier]').forEach(function (btn) {
      btn.addEventListener('click', function () {
        setTier(btn.getAttribute('data-sc-configure-tier'));
      });
    });

    render();
  }

  /* ---------- form: phone-vs-email guard ----------
     The single "Phone or email" field posts as contact[email], which
     Shopify validates as an email. Catch phone-style entries client-side
     with a friendlier, styled message before the round-trip. */
  var contactField = document.getElementById('sc-contact-field');
  if (contactField && contactField.form) {
    contactField.form.addEventListener('submit', function (e) {
      var v = contactField.value.trim();
      if (v && !/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(v)) {
        e.preventDefault();
        var note = document.getElementById('sc-contact-note');
        if (!note) {
          note = document.createElement('div');
          note.id = 'sc-contact-note';
          note.className = 'sc-form__errors';
          note.setAttribute('role', 'alert');
          contactField.closest('.sc-form__row').insertAdjacentElement('beforebegin', note);
        }
        note.innerHTML = 'Booking online needs an email address. Prefer phone? ' +
          'Text or call <a href="tel:' + (contactField.getAttribute('data-tel') || '') + '">' +
          (contactField.getAttribute('data-tel-label') || 'us') +
          '</a> and we’ll take it from there.';
        contactField.focus();
      }
    });
  }

  /* ---------- form: land on the panel after a post ---------- */
  var success = document.getElementById('sc-form-success');
  var errors = document.querySelector('.sc-form__errors');
  if (success || errors) {
    var panel = document.getElementById('consult');
    if (panel) {
      window.setTimeout(function () {
        panel.scrollIntoView({ behavior: 'auto', block: 'start' });
      }, 0);
    }
  }

  /* Google Ads conversion labels. The main-window Google tag has NO GA4
     destination (verified 6 Aug 2026), so these events never reach GA4 and
     GA4-imported conversion actions can never record them. Fire them straight
     at the Ads tag, AW-17721956038, which IS loaded in the main window here. */
  var SC_ADS_LABELS = {
    consult_request: 'AW-17721956038/2cYMCKHxtd0cEMatvoJC',
    consult_call_click: 'AW-17721956038/HTFdCOqwpN0cEMatvoJC',
    consult_text_click: 'AW-17721956038/P_0PCO2wpN0cEMatvoJC'
  };

  function scTrack(name, params) {
    try {
      if (typeof window.gtag === 'function') {
        window.gtag('event', name, params || {});
        if (SC_ADS_LABELS[name]) {
          window.gtag('event', 'conversion', { send_to: SC_ADS_LABELS[name] });
        }
      }
    } catch (e) {
      /* swallow: a tracking failure must not affect the consult flow */
    }
  }

  /* (1) Consult form posted successfully.
     Shopify re-renders this page with the success panel after a valid
     post, so the panel's presence is the reliable signal — more robust
     than sniffing query strings. Deduped per path so that a refresh or a
     back-navigation onto the posted URL doesn't double-count the lead. */
  if (success) {
    var alreadyCounted = false;
    try {
      var stampKey = 'sc_consult_counted:' + window.location.pathname;
      alreadyCounted = window.sessionStorage.getItem(stampKey) === '1';
      if (!alreadyCounted) window.sessionStorage.setItem(stampKey, '1');
    } catch (e) {
      /* sessionStorage blocked; proceed and accept a possible duplicate */
    }
    if (!alreadyCounted) {
      scTrack('consult_request', { lead_source: 'simpatico_customs_form' });
    }
  }

  /* (2) Text/call number tapped. Delegated so it covers both the phone
     card and the number inside the success panel, and keeps working if
     either is re-rendered. Capture phase so it still records when the
     browser hands the tel: link off to the dialer. */
  document.addEventListener('click', function (e) {
    var link = e.target && e.target.closest
      ? e.target.closest('a[href^="tel:"]')
      : null;
    if (!link) return;
    scTrack('consult_call_click', {
      lead_source: 'simpatico_customs_phone',
      placement: link.closest('.sc-phonecard')
        ? 'phone_card'
        : (link.closest('.sc-success') ? 'success_panel' : 'other')
    });
  }, true);
})();
